<div class="paginator">
  <p class="paginator-legend">Mostrando: {{ (pagina-1) * qtdPorPagina+1 }} até {{ (pagina * qtdPorPagina) >
    totalRegistros ? totalRegistros : (pagina * qtdPorPagina) }} de {{ totalRegistros }} registros</p>

    <ul class="paginator-action">
    <button
        [disabled]="isFirstPagina"
        class="paginator-button"
        (click)="paginar(pagina-1, $event)"
        [ngClass]="{'deactive': isFirstPagina}">
      <span aria-hidden="true">Anterior</span>
    </button>

    <div
        class="paginator-number"
        [ngClass]="{'active': i===pagina}"
        (click)="paginar(i, $event)"
        *ngFor="let i of paginas">
        {{ i }}
    </div>

    <button
        [disabled]="isLastPagina"
        class="paginator-button"
        (click)="paginar(pagina+1, $event)"
        [ngClass]="{'deactive': isLastPagina}">
      <span aria-hidden="true">Seguinte</span>
    </button>
  </ul>
</div>
